import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollTop({setNavbar}) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    setNavbar(false);
  }, [pathname]);

  return true;
}